import { SECTION_TITLES } from './consts'
import { useReportTranslation } from 'utilities/i18n'

// Maps a stable (English) section identity from SECTION_TITLES to its catalog
// key. The SECTION_TITLES values stay the identity used for data-cy selectors,
// hidden/has-data Set membership, and Cypress assertions; only the displayed
// header text is localized through these keys.
export const SECTION_TITLE_KEYS = {
  [SECTION_TITLES.EMERGENCY_DEPT_VISIT]: 'report.section.emergencyDeptVisit',
  [SECTION_TITLES.RED_FLAGS]: 'report.section.redFlags',
  [SECTION_TITLES.OTHER_ISSUES]: 'report.section.otherIssues',
  [SECTION_TITLES.HIGHLIGHTS]: 'report.section.highlights',
  [SECTION_TITLES.DYSKINESIA_MANAGEMENT]: 'report.section.dyskinesiaManagement',
  [SECTION_TITLES.SYMPTOM_LOG]: 'report.section.symptomLog',
  [SECTION_TITLES.TREMOR]: 'report.section.tremor',
  [SECTION_TITLES.DYSKINESIA]: 'report.section.dyskinesia',
  [SECTION_TITLES.ACTIVITY]: 'report.section.activity',
  [SECTION_TITLES.MOBILITY]: 'report.section.mobility',
  [SECTION_TITLES.MEDICATION]: 'report.section.medication',
  [SECTION_TITLES.SUPPORTING_MATERIALS]: 'report.section.supportingMaterials',
  [SECTION_TITLES.SUPPORTING_MATERIALS_RED_FLAGS_AND_OTHER_REPORTED_ISSUES]:
    'report.section.supportingMaterialsRedFlags',
  [SECTION_TITLES.TOP_CONCERNS]: 'report.section.topConcerns',
}

// Returns a function that maps a section identity to its localized display
// title. Unknown identities are returned unchanged so data-cy selectors and
// Cypress assertions keep working; add new sections to SECTION_TITLE_KEYS.
export const useSectionTitle = () => {
  const { t } = useReportTranslation()
  return (identity) => {
    const key = SECTION_TITLE_KEYS[identity]
    if (!key) {
      if (process.env.NODE_ENV === 'development' && identity) {
        // eslint-disable-next-line no-console
        console.warn(
          `[report i18n] No SECTION_TITLE_KEYS mapping for section identity: ${identity}`,
        )
      }
      return identity
    }
    return t(key)
  }
}
